module.exports = __webpack_public_path__ + "img/icon-upload.d460f8b9.png";